import React from 'react';

const FollowUpCoachingCompo = () => {
    return (
        <div className='mx-auto mb-10'>
            <h1 className='text-md my-5'>Because Nutrition coaching is a continuous process! Achieving
                health and fitness related goals is not a quick fix or a one-time
                event, but rather a lifelong journey. We will guide you with the
                knowledge and skills needed to make positive behavior changes
                that last a lifetime.</h1>

        </div>
    );
};

export default FollowUpCoachingCompo;